import { ROLE } from '../../types';

export const ROLE_HIERARCHY: Record<string, string[]> = {
  [ROLE.ROLE_ADMIN]: [
    ROLE.ROLE_SUPPORT,
    ROLE.ROLE_MAPAQ,
    ROLE.ROLE_DETENTEUR_PERMIS,
    ROLE.ROLE_IMPORTATION_PERMIS,
    ROLE.ROLE_VET,
    ROLE.ROLE_PRODUCER,
    ROLE.ROLE_USER,
    ROLE.ROLE_ASSOCIATION,
    ROLE.ROLE_FMV,
    ROLE.ROLE_VET_SOFTWARE_SUPPLIER,
  ],
  [ROLE.ROLE_SUPPORT]: [
    ROLE.ROLE_SUPPORT_RO,
    ROLE.ROLE_MAPAQ,
    ROLE.ROLE_DETENTEUR_PERMIS,
    ROLE.ROLE_IMPORTATION_PERMIS,
    ROLE.ROLE_VET,
    ROLE.ROLE_PRODUCER,
    ROLE.ROLE_USER,
    ROLE.ROLE_ASSOCIATION,
    ROLE.ROLE_FMV,
    ROLE.ROLE_VET_SOFTWARE_SUPPLIER,
  ],
  [ROLE.ROLE_MAPAQ]: [ROLE.ROLE_MAPAQ_RO, ROLE.ROLE_ASSOCIATION, ROLE.ROLE_VET_SOFTWARE_SUPPLIER],
  [ROLE.ROLE_SUPPORT_RO]: [ROLE.ROLE_USER],
  [ROLE.ROLE_MAPAQ_RO]: [ROLE.ROLE_USER],
  [ROLE.ROLE_ASSOCIATION]: [ROLE.ROLE_USER],
  [ROLE.ROLE_DETENTEUR_PERMIS]: [ROLE.ROLE_USER],
  [ROLE.ROLE_IMPORTATION_PERMIS]: [ROLE.ROLE_USER],
  [ROLE.ROLE_VET]: [ROLE.ROLE_USER],
  [ROLE.ROLE_FMV]: [ROLE.ROLE_USER],
  [ROLE.ROLE_PRODUCER]: [ROLE.ROLE_USER],
  [ROLE.ROLE_VET_SOFTWARE_SUPPLIER]: [ROLE.ROLE_USER],
  [ROLE.ROLE_USER]: [],
};

export const isHigherRole = (
  candidateRole: string,
  comparedRole: string,
  visited = new Set<string>()
): boolean => {
  if (visited.has(candidateRole)) {
    return false;
  }

  visited.add(candidateRole);
  const inheritedRoles = ROLE_HIERARCHY[candidateRole] ?? [];

  return (
    inheritedRoles.includes(comparedRole) ||
    inheritedRoles.some(inheritedRole => isHigherRole(inheritedRole, comparedRole, visited))
  );
};

export const isSameOrHigherRole = (candidateRole: string, comparedRole: string) =>
  candidateRole === comparedRole || isHigherRole(candidateRole, comparedRole);
